import Notification from 'flarum/forum/components/Notification';

export default class PostDislikedNotification extends Notification {
  icon() {
    return 'fas fa-thumbs-down';
  }

  href() {
    return app.route.post(this.attrs.notification.subject());
  }

  content() {
    const user = this.attrs.notification.fromUser();
    return app.translator.trans('happydigital-post-reactions.forum.notifications.post_disliked_text', {
      username: user.displayName(),
      title: this.attrs.notification.subject().discussion().title(),
    });
  }

  excerpt() {
    return this.attrs.notification.subject().contentPlain();
  }
}
